import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { ActivatedRoute, Router } from '@angular/router';
import { UserRole } from 'src/app/models/api/user';
import { AuthService } from 'src/app/services/auth/auth.service';
import { BuildDetailsService } from 'src/app/services/background/build-details.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { environment } from 'src/environments/environment';
import { ReferDialogComponent } from '../refer-dialog/refer-dialog.component';
import { SearchBarComponent } from '../search-bar/search-bar.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger('toggleMenu', [
      state(
        'closed',
        style({
          height: '0px',
          paddingTop: '0px',
          paddingBottom: '0px',
        })
      ),
      state(
        'open',
        style({
          height: 'auto',
        })
      ),
      transition('closed=>open', animate('300ms')),
      transition('open=>closed', animate('300ms')),
    ]),
  ],
})
export class HeaderComponent implements OnInit {
  @Input() isFullScreen = false;
  @Input() isMenuHidden = false;
  @ViewChild('tooltip') tooltip: MatTooltip;

  isSticky = false;
  isLoggedInStatic = false;
  isMobileMenuOpen = false;
  isMobileNotificationsOpen = false;
  isDesktopSearchOpen = false;
  isBannerOpen = false;

  isLandingPage = false;
  isSchoolPage = false;

  showApplicationTooltip = false;

  events: string[] = [];
  opened: boolean;

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    this.isSticky = window.pageYOffset >= 80;
    this.resizeHeader();
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private buildDetailsService: BuildDetailsService,
    private notificationService: NotificationService,
    private elementRef: ElementRef,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.isBannerOpen = false;
    this.resizeHeader();
    this.isLoggedInStatic = this.authService.isAuthenticated();
    this.isLandingPage = this.getPageUrl() === '/';
    this.isSchoolPage = this.getPageUrl().includes('/school/');

    this.notificationService.applicationAdded.subscribe((_) => {
      if (screen.width > 959) {
        this.showApplicationTooltip = true;
        setTimeout(() => this.tooltip.show(0), 100);
        setTimeout(() => (this.showApplicationTooltip = false), 6000);
      } else {
        this.notificationService.showSuccess(
          'You can access your shortlisted programs from the ≡ menu'
        );
      }
    });
  }

  isLoggedIn() {
    return this.authService.isAuthenticated();
  }

  isAgent() {
    return (
      this.isLoggedIn() && this.authService.getUserRole() === UserRole.Agent
    );
  }

  logout() {
    this.authService.logout();

    if (this.isMobileMenuOpen) {
      this.isMobileMenuOpen = false;
    }

    this.router.navigateByUrl('/');
  }

  showBanner() {
    this.isBannerOpen = true;
    this.resizeHeader();
  }

  closeBanner() {
    this.isBannerOpen = false;
    this.resizeHeader();
  }

  openDesktopSearch() {
    this.isDesktopSearchOpen = true;
    this.resizeHeader();
  }

  closeDesktopSearch() {
    this.isDesktopSearchOpen = false;
    this.resizeHeader();
  }

  resizeHeader() {
    let height = 128;

    if (this.isSticky) height = 64;
    if (this.isBannerOpen) height += 80;
    if (this.isDesktopSearchOpen) height += 120;

    this.elementRef.nativeElement.style.setProperty(
      '--header-size',
      height + 'px'
    );
  }

  scrollToSearch() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  openSearch() {
    this.dialog.open(SearchBarComponent, {
      width: '100%',
      data: {
        source: 'search_bar',
      },
    });
  }

  showReferModal() {
    this.dialog.open(ReferDialogComponent, {
      width: '400px',
      autoFocus: false,
    });
  }

  getProfileName() {
    return this.authService.getUserFullName();
  }

  getProfileImage() {
    return this.authService.getUserImage();
  }

  getProfileEmail() {
    return this.authService.getUserEmail();
  }

  getPageUrl() {
    return new URL(document.URL).pathname;
  }

  get isDevelopmentBuild() {
    return !environment.production;
  }

  get buildVersion() {
    return this.buildDetailsService.getBuildVersion();
  }
}
